<template>
  <v-layout>
    <v-flex v-if="haveDates">
      <div v-if="reportsPending">
        <v-flex>
          Getting timecard entries...
          <v-progress-linear indeterminate></v-progress-linear>
        </v-flex>
      </div>
      <div v-else>
        <v-layout column full-width>
          <v-layout row>
            <template>
              <v-flex>
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="Start Date"
                      format="dddd, MM DD YYYY"
                      @change="value => startDate = value"
                      :value="dateFormatted(startDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker :show-current="endDate" v-model="startDate" @input="startDateMenu = false" no-title scrollable>
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <template>
              <v-flex>
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator" slot-scope="{ on }">
                    <v-text-field
                      label="End Date"
                      format="dddd, MM DD YYYY"
                      @change="value => endDate = value"
                      :value="dateFormatted(endDate)"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker :show-current="startDate" v-model="endDate" @input="endDateMenu = false" no-title scrollable>
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </template>
            <v-btn @click="reGetRecords" color="primary">
              Change Dates
            </v-btn>
          </v-layout>

          <v-dialog v-model="isShiftExpanded" v-if="isShiftExpanded">
            <v-card v-if="!havePunches">
              <v-card-text>
                <v-progress-linear indeterminate></v-progress-linear>
              </v-card-text>
            </v-card>
            <v-card v-else>
              <v-card-text>
                <v-layout justify-end column class="text-xs-right mb-3">
                  <v-layout row justify-space-between>
                    <h2 class="subheading mb-2">Timecard entries for <span class="font-weight-bold">{{ shiftExpanded.workerName }}</span> as {{ shiftExpanded.positionWorked }} starting on <span class="font-weight-bold">{{ shiftExpanded.startDatetime | moment("dddd MMMM D, YYYY") }}</span></h2>
                    <v-flex class="mb-4">
                      <v-icon @click="isShiftExpanded = false">close</v-icon>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <v-layout column>
                  <v-flex class="mb-4">
                    <div>
                      <ul>
                      <li v-if="shiftExpanded.straightBonus">
                        {{ shiftExpanded.straightBonusAmount }}
                        <v-icon small v-if="shiftExpanded.straightBonus">local_atm</v-icon>
                        Straight Bonus
                      </li>
                      <li v-if="shiftExpanded.callInBonus">
                        {{ shiftExpanded.callInBonusAmount }}
                        <v-icon small v-if="shiftExpanded.callInBonus">phone</v-icon>
                        Call-in Bonus
                      </li>
                      <li v-if="shiftExpanded.travelBonus">
                        {{ shiftExpanded.travelBonusAmount }}
                        <v-icon small v-if="shiftExpanded.travelBonus">directions_car</v-icon>
                        Travel Bonus
                      </li>
                      </ul>
                    </div>
                  </v-flex>
                  <v-flex class="mb-4">
                    <div>
                      <div v-if="shiftExpanded.employeeNotes">
                        Employee's Notes: {{ shiftExpanded.employeeNotes }}
                      </div>
                      <div v-if="shiftExpanded.clientNotes">
                        Clients's Notes: {{ shiftExpanded.clientNotes }}
                      </div>
                    </div>
                  </v-flex>
                    <ApiField
                      v-if="user.bohOrHigher"
                      fieldType="switch"
                      label="Employee was absent"
                      storeAction="shifts/update"
                      storeUpdate="shifts/updateViewedShift"
                      paramName="shift"
                      :object="shiftExpanded"
                      fieldName="employee_absent"
                      :storeFieldValue="shiftExpanded.employeeAbsent"
                    >
                    </ApiField>
                  <v-layout v-if="!sortedPunches || sortedPunches.length < 1">
                    <h2 class="subheading text-xs-center">No timeclock entries!</h2>
                  </v-layout>
                  <v-layout v-else row>
                    <v-flex grow>
                      <table style="width: 100%;">
                        <thead>
                          <tr>
                            <th class="text-xs-left">Edit</th>
                            <th class="text-xs-left">Type</th>
                            <th class="text-xs-left">Date</th>
                            <th class="text-xs-left">Time</th>
                            <th class="text-xs-right">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <PunchRow
                            :punch="punch"
                            v-for="punch in sortedPunches"
                            :key="punch.id"
                            :editable="user.bohOrHigher"
                          >
                          </PunchRow>
                        </tbody>
                      </table>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="user.bohOrHigher" row class="mt-4 text-xs-right">
                    <v-flex>
                      <v-btn class="no-margin" :loading="timeclockCreatePending" :disabled="timeclockCreatePending" @click="createManagerClockEntry" color="success">
                        <v-icon left>
                          add
                        </v-icon>
                        Timeclock entry
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-card>
            <v-card-title>
              <v-layout column>
                <v-layout row>
                  <h2 v-if="user.clientAdmin || user.managerOrHigher" class="display-1">Timecard - All Locations</h2>
                  <h2 v-if="user.clientOrHigher && !user.clientAdmin && !user.managerOrHigher" class="display-1">Timecard - My Locations</h2>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search in this page"
                    single-line
                    hide-details
                    clearable
                  >
                  </v-text-field>
                </v-layout>
                <v-layout row class="mt-2">
                  <v-checkbox
                    v-model="advancedOptions"
                    label="Extra Filters"
                  ></v-checkbox>
                  <v-btn @click="csvExport" color="primary" :disabled="shiftsFiltered < 1">
                    <v-icon left small>
                      save_alt
                    </v-icon>
                    Export Current Page
                  </v-btn>
                </v-layout>

                <v-layout v-if="advancedOptions" class="text-xs-center" column justify-content-space-around>
                  <v-layout row>
                    <v-flex>
                      <span class="subtle">Note: These filters only apply to the current page</span>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex>
                      <v-switch
                        switch
                        v-model="hideUnassigned"
                        label="Hide Unassigned Shifts"
                      >
                      </v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex>
                      <v-switch
                        switch
                        v-model="hideUnclockedIn"
                        label="Only Show Clocked-In"
                      >
                      </v-switch>
                    </v-flex>
                    <v-flex>
                      <v-switch
                        switch
                        v-model="hideClockedIn"
                        label="Only Show No-Clock-In"
                      >
                      </v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex>
                      <v-switch
                        switch
                        v-model="hideWithoutClockedOut"
                        label="Only Show Clocked-Out"
                      >
                      </v-switch>
                    </v-flex>
                    <v-flex>
                      <v-switch
                        switch
                        v-model="hideClockedOut"
                        label="Only Show No-Clock-Out"
                      >
                      </v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex>
                      <v-switch
                        switch
                        v-model="hideUnabsent"
                        label="Only Show Absent"
                      >
                      </v-switch>
                    </v-flex>
                  </v-layout>
                </v-layout>

                <v-layout row justify-center align-center class="text-xs-center">
                  <v-flex>
                    <v-pagination
                      v-model="page"
                      :length="pageLength"
                    >
                    </v-pagination>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-card-title>

              <v-layout row class="px-2" align-center>
                <v-flex xs4>
                  <v-select
                    v-model="limit"
                    :items="limitOptions"
                    label="Records Per Page"
                  />
                </v-flex>
                <v-flex class="text-xs-right">
                  <span class="subtle caption">{{ `${ queryTotal } record${ queryTotal == 1 ? '' : 's' }` }} in this search</span>
                </v-flex>
              </v-layout>
            <v-data-table
              ref="shiftsTable"
              :headers="headers"
               :items="shiftsFiltered"
               item-key="id"
               :search="search"
               :pagination.sync="defaultSort"
               class="elevation-1"
               hide-actions
            >
              <template slot="no-data">
                <v-alert :value="true" color="warning">
                  No records to show. This can happen if you change the date range or the records per page. <strong>Try clicking a page number above.</strong>
                </v-alert>
              </template>
              <template slot="items" slot-scope="{ item }">
                <tr @click="expand(item)">
                  <td>
                    {{ item.startDatetime | moment("dddd MMMM D, YYYY") }}
                    <span v-if="user.clientAdmin || user.managerOrHigher">

                    <router-link
                      :to="{ name: 'shiftDetail', params: { shiftId: item.id } }"
                      target="_blank"
                    >
                    <v-icon small>open_in_new</v-icon>
                    </router-link>
                    </span>
                  </td>
                  <td>{{ item.locationName }}</td>
                  <td>{{ item.workerName }}</td>
                  <td>{{ item.positionWorked }}</td>
                  <td>
                    <span>{{ item.startDatetime | moment("h:mma") }}</span> /
                    <span :class="startPunchClass(item)">
                      <template v-if="startPunchFrom(item)">
                        {{ startPunchFrom(item).punch_time | moment("h:mma") }}
                      </template>
                      <template v-else>
                        N/A
                      </template>
                    </span>
                  </td>
                  <td>
                    <span>{{ item.endDatetime | moment("h:mma") }}</span> /
                    <span :class="endPunchClass(item)">
                      <template v-if="endPunchFrom(item)">
                        {{ endPunchFrom(item).punch_time | moment("h:mma") }}
                      </template>
                      <template v-else>
                        N/A
                      </template>
                    </span>
                  </td>
                  <td>
                    {{ item.employeeAbsent ? 'Absent' : item.hoursWorked }}
                  </td>
                  <td>
                    <v-icon small v-if="user.bohOrHigher && (item.employeeNotes || item.clientNotes)">
                      note
                    </v-icon>
                  </td>
                  <td>
                    <v-layout row>
                      <v-icon small v-if="item.straightBonus">local_atm</v-icon>
                      <v-icon small v-if="item.travelBonus">directions_car</v-icon>
                      <v-icon small v-if="item.callInBonus">phone</v-icon>
                    </v-layout>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-layout>

        <v-layout row justify-center align-center class="text-xs-center mt-4">
          <v-flex>
            <v-pagination
              v-model="page"
              :length="pageLength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex v-else>
      Something is wrong with the dates in the url
    </v-flex>
  </v-layout>
</template>

<script>
import ApiField from '@/components/base/api-field.vue'
import { mapState, mapGetters } from 'vuex'
import PunchRow from '@/components/calendar/punch.vue'
import { ExportToCsv } from 'export-to-csv';

export default {
  components: {
    PunchRow,
    ApiField,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapGetters('timeclock', [
      'sortedPunches',
    ]),
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        limit: this.limit,
        offset: this.computedOffset,
        page: this.page,
      }
    },
    shiftsFiltered: function () {
      var filtered = this.shifts
      if (this.hideUnassigned) {
        filtered = filtered.filter(s => s.workerId)
      }

      if (this.hideUnclockedIn) {
        filtered = filtered.filter(s => {
          if (s.punches.find(p => (p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideClockedIn) {
        filtered = filtered.filter(s => {
          if (!s.punches.find(p => (p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideClockedOut) {
        filtered = filtered.filter(s => {
          if (!s.punches.find(p => (!p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideWithoutClockedOut) {
        filtered = filtered.filter(s => {
          if (s.punches.find(p => (!p.start && p.endcap))) {
            return s
          }
        })
      }

      if (this.hideUnabsent) {
        filtered = filtered.filter(s => {
          if (s.employeeAbsent) {
            return s
          }
        })
      }

      return filtered
    },
    computedOffset: function () {
      return this.limit * (this.page - 1)
    },
    pageLength: function () {
      return Math.ceil(this.queryTotal / this.limit)
    },
  },
  created () {
    const startDate = this.$route.query.startDate
    const endDate = this.$route.query.endDate
    this.page = parseInt(this.$route.query.page) || this.page
    this.limit = parseInt(this.$route.query.limit) || this.limit
    if (startDate && endDate) {
      this.startDate = startDate
      this.endDate = endDate
      this.haveDates = true
    } else {
      this.haveDates = false
    }
  },
  watch: {
    'haveDates' : {
      handler(haveDates) {
        this.getReports(haveDates)
      }
    },
    'isShiftExpanded' : {
      handler(open) {
        this.closeExpansion(open)
      }
    },
    'advancedOptions' : {
      handler(checked) {
        if (!checked) {
          this.resetFilters()
        }
      }
    },
    'page': {
      handler(value) {
        if (value != this.$route.query.page) {
          this.reGetRecords()
        } else {
        }
      }
    },
    'limit': {
      handler(value) {
        if (value != this.$route.query.limit) {
          this.reGetRecords()
        } else {
        }
      }
    }
  },
  data: function () {
    return {
      timeclockCreatePending: false,
      isShiftExpanded: false,
      shiftExpanded: null,
      havePunches: true,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract(3, "weeks").format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(1, "weeks").format('YYYY-MM-DD'),
      haveDates: false,
      limit: 30,
      limitOptions: [
        { text: "15", value: 15 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      page: 1,
      queryTotal: 0,
      reportsPending: true,
      shifts: [],
      search: '',
      advancedOptions: false,
      hideUnassigned: false,
      hideUnclockedIn: false,
      hideClockedIn: false,
      hideClockedOut: false,
      hideWithoutClockedOut: false,
      hideUnabsent: false,
      defaultSort: {
        sortBy: 'order',
        rowsPerPage: -1, //all
      },
      headers: [
        { text: 'Date', value: 'startDatetime' },
        { text: 'Location Name', sortable: true, value: 'locationName' },
        { text: 'Employee Name', sortable: true, value: 'workerLastName' },
        { text: 'Position Worked', value: 'positionWorked' },
        { text: 'Scheduled Start / Clocked in', sortable: false, value: 'startDatetime' },
        { text: 'Scheduled End / Clocked out', sortable: false},
        { text: 'Hours Worked', sortable: true, value: 'hoursWorked' },
        { text: 'Notes', sortable: true, value: 'anyNotes' },
        { text: 'Bonuses', sortable: false },
      ],
    }
  },

  methods: {
    csvExport: function () {

      const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: false,
        filename: `timecard-all-locations_${ this.$moment().format('YYYY-MM-DD_HH-mm-ss') }`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      // const shiftsToExport = this.$refs.shiftsTable.filteredItems.map(s => {
      const shiftsToExport = this.shiftsFiltered.map(s => {
        s['Shift ID'] = s.id
        delete s.id
        s['Location Name'] = s.locationName
        delete s.locationName
        s['Scheduled Start Date'] = this.$moment(s.startDatetime).format("YYYY-MM-DD")
        s['Scheduled Start Time'] = this.$moment(s.startDatetime).format("h:mma")
        delete s.startDatetime
        const clockIn = this.startPunchFrom(s)
        if (clockIn) {
          s['Clock In Date'] = this.$moment(clockIn.punch_time).format("YYYY-MM-DD")
          s['Clock In Time'] = this.$moment(clockIn.punch_time).format("h:mma")
        } else {
          s['Clock In Date'] = ''
          s['Clock In Time'] = ''
        }
        s['Scheduled End Date'] = this.$moment(s.endDatetime).format("YYYY-MM-DD")
        s['Scheduled End Time'] = this.$moment(s.endDatetime).format("h:mma")
        delete s.endDatetime
        const clockOut = this.endPunchFrom(s)
        if (clockOut) {
          s['Clock Out Date'] = this.$moment(clockOut.punch_time).format("YYYY-MM-DD")
          s['Clock Out Time'] = this.$moment(clockOut.punch_time).format("h:mma")
        } else {
          s['Clock Out Date'] = ''
          s['Clock Out Time'] = ''
        }
        delete s.punches
        s['Hours Worked'] = s.hoursWorked
        delete s.hoursWorked

        s['Absent?'] = s.employeeAbsent ? 'Absent' : ''

        s['Employee Fullname'] = s.workerName
        delete s.workerName
        s['Employee First Name'] = s.workerFirstName
        delete s.workerFirstName
        s['Employee Last Name'] = s.workerLastName
        delete s.workerLastName
        s['Employee ID'] = s.workerId || ''
        delete s.workerId
        s['Position Worked'] = s.positionWorked
        delete s.positionWorked
        if (this.user.bohOrHigher) {
          s['Employee Notes'] = s.employeeNotes || ''
        } else {
          s['Employee Notes'] = ''
        }
        delete s.employeeNotes
        s['Client Notes'] = s.clientNotes || ''
        delete s.clientNotes

        delete s.anyNotes
        delete s.straightBonus
        s['Straight Bonus Amount'] = s.straightBonusAmount === '$0' ? '' : s.straightBonusAmount
        delete s.straightBonusAmount

        delete s.travelBonus
        s['Travel Bonus Amount'] = s.travelBonusAmount === '$0' ? '' : s.travelBonusAmount
        delete s.travelBonusAmount

        delete s.callInBonus
        s['Call In Bonus Amount'] = s.callInBonusAmount === '$0' ? '' : s.callInBonusAmount
        delete s.callInBonusAmount

        return s
      })

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(shiftsToExport);
    },
    resetFilters: function () {
      this.hideUnassigned = false
      this.hideUnclockedIn = false
      this.hideClockedIn = false
      this.hideClockedOut = false
      this.hideWithoutClockedOut = false
    },
    startPunchFrom: function (shift) {
      return shift.punches.find(p => {
        return (p.start && p.endcap)
      })
    },
    startPunchClass: function (shift) {
      var classList = []
      if (!this.startPunchFrom(shift)) {
        classList.push('grey--text')
      } else {
        classList.push('font-weight-bold')
        const clockInTime = this.startPunchFrom(shift).punch_time
        const scheduledInTime = shift.startDatetime
        const diff = this.$moment(clockInTime).diff(this.$moment(scheduledInTime), 'minutes')
        if (Math.abs(diff) > 15) {
          classList.push('red--text')
        }
      }
      return classList
    },
    endPunchFrom: function (shift) {
      return shift.punches.find(p => {
        return (!p.start && p.endcap)
      })
    },
    endPunchClass: function (shift) {
      var classList = []
      if (!this.endPunchFrom(shift)) {
        classList.push('grey--text')
      } else {
        classList.push('font-weight-bold')
        const clockInTime = this.endPunchFrom(shift).punch_time
        const scheduledInTime = shift.endDatetime
        const diff = this.$moment(clockInTime).diff(this.$moment(scheduledInTime), 'minutes')
        if (Math.abs(diff) > 15) {
          classList.push('red--text')
        }
      }
      return classList
    },
    dateFormatted: function (date) {
      return date ? this.$moment(date).format('dddd, MMMM D') : ''
    },
    getReports (haveDates) {
      if (haveDates) {
        this.reportsPending = true
        this.$store.dispatch('reports/getTimeclockAllLocations', {
          startDate: this.startDate,
          endDate: this.endDate,
          limit: this.limit,
          offset: this.computedOffset,
          page: this.page,
        }).then(response => {
          this.queryTotal = response.total
          this.shifts = response.shifts
        }).catch(err => {
          console.log(err)
        }).finally(res => {
          this.reportsPending = false
        })
      }
    },
    back: function () {
      this.$router.push({
        name: 'timeclockReports',
        query: {
          startDate: this.startDate,
          endDate: this.endDate,
        }
      })
    },
    reGetRecords: function (datesChanged) {
      if (datesChanged) {
        this.getReports(this.haveDates)
      }
      this.$router.push({
        name: 'timeclockReports',
        query: this.formattedQuery
      })
    },
    expand: function(shift) {
      if (!this.user.bohOrHigher) {
        return
      }

      if (!shift.workerName) {
        return
      }
      this.isShiftExpanded = true
      this.shiftExpanded = shift
      this.havePunches = false
      this.$store.dispatch('timeclock/getPunches', { shiftId: shift.id })
      .finally(res => {
        this.havePunches = true
      })
    },
    closeExpansion: function (open) {
      if (!open) {
        this.shiftExpanded = null
        this.isShiftExpanded = false
        // TODO: maybe update something or other based on changes made in modal?
      }
    },
    createManagerClockEntry () {
      this.timeclockCreatePending = true
      this.$store.dispatch('timeclock/managerCreate', this.shiftExpanded.id)
      .then(res => {
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Timeclock entry created! Be sure to update it." })
      })
      .catch(err => {
        this.$store.dispatch('global/showSnackbarError', { message: "There was a problem creating a timeclock entry" })
      })
      .finally(res => {
        this.timeclockCreatePending = false
      })
    },
  },
}
</script>

<style scoped>
</style>
